// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"f57db9af","239":"e39fb35b","455":"1b991356","481":"430d3372","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};